
import Vue from "vue";
import { Component, ModelSync, Prop } from "vue-property-decorator";

import { ControlRepeater } from "@/oxygen/classes/lib/types";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import defensiveCopy from "@/util/defensive-copy";
import { RepeaterOptions } from "@/types/controls";

@Component({
  components: { Repeater }
})
export default class OxygenRepeaterInput extends Vue {
  @Prop()
  control!: ControlRepeater;

  @ModelSync("value", "input")
  syncedValue?: unknown[];

  @Prop()
  path!: string;

  beforeCreate() {
    // @ts-ignore
    this.$options.components.OxygenControls =
      require("@/oxygen/classes/OxygenControls.vue").default;
  }

  get isDisabled() {
    return "";
  }

  get options(): RepeaterOptions {
    return {
      popupMode: true,
      itemIcon: this.control.itemIcon,
      itemColorPath: this.control.itemColorPath,
      // @ts-ignore We cannot type functions with io-ts
      titleTemplate: this.control.titleTemplate,
      defaultTitle: this.control.defaultTitle,
      buttonName: this.control.buttonName,
      defaultNewValue: this.control.defaultNewValue,
      duplicateNewValue: this.control.duplicateNewValue,
      deleteText: this.control.deleteText,
      noDuplicate: this.control.noDuplicate,
      noDisable: this.control.noDisable,
      noDataMessage: this.control.noDataMessage,
      noExpand: this.control.noExpand
    };
  }

  updateItem(value: unknown, index: number) {
    const newValue = defensiveCopy(this.syncedValue) || [];
    newValue[index] = value;
    this.$emit("input", newValue);
  }
}
